export enum CustomIcons {
    COMPLETE_CHECK = 'complete-check',
    LIVE_AGENT = 'live-agent'
}
